import(/* webpackMode: "eager", webpackExports: ["ProjectCardsSection"] */ "/home/runner/work/personal-website/personal-website/components/ProjectCard/ProjectCard.tsx");
